import { on, createReducer, createFeature } from '@ngrx/store';
import { Availability } from '../../../objects/availability';
import { AvailabilityActions } from '../actions';

export interface State {
  availabilities: Availability[] | null;
  availabilitiesLoading: boolean;

  selectedAvailabilities: Availability[] | null;

  error: Error | null;
}

export const initialState: State = {
  availabilities: null,
  availabilitiesLoading: false,

  selectedAvailabilities: null,

  error: null,
};

export const availabilityFeature = createFeature({
  name: 'availability',
  reducer: createReducer(
    initialState,
    on(AvailabilityActions.loadAvailabilities, state => ({
      ...state,
      availabilities: null,
      availabilitiesLoading: true,
      selectedAvailabilities: [],
      error: null,
    })),
    on(AvailabilityActions.loadAvailabilitiesSuccess, (state, { availabilities }) => ({
      ...state,
      availabilities,
      availabilitiesLoading: false,
      error: null,
    })),
    on(AvailabilityActions.loadAvailabilitiesFailure, (state, { error }) => ({
      ...state,
      availabilities: null,
      availabilitiesLoading: false,
      error,
    })),

    on(AvailabilityActions.setSelectedAvailabilities, (state, { availabilities }) => ({
      ...state,
      selectedAvailabilities: availabilities,
    })),
  ),
});

export const {
  name: availabilityFeatureKey,
  reducer,
  selectAvailabilityState,
  selectAvailabilities,
  selectAvailabilitiesLoading,
  selectSelectedAvailabilities,
  selectError: selectAvailabilityError,
} = availabilityFeature;
